'use strict';

import _ from 'lodash';
import React, { Component } from 'react';

// Import the CSS
import '../../scss/_icons.scss';

export default class Icon extends Component {
	render () {

		const props = _.omit(this.props, [ 'className', 'type' ]);
		const classes = [ 'icon', `icon-${this.props.type}` ];

		if (this.props.className) {
			classes.push(this.props.className);
		}

		return (
			<span className={ classes.join(' ') } { ...props } />
		);
	}
}

Icon.propTypes = {
	type: React.PropTypes.string.isRequired,
	className: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/assets/js/components/Icon.js